import { render, staticRenderFns } from "./SettingExportModal.vue?vue&type=template&id=5c1b41bc&scoped=true&"
import script from "./SettingExportModal.vue?vue&type=script&lang=js&"
export * from "./SettingExportModal.vue?vue&type=script&lang=js&"
import style0 from "./SettingExportModal.vue?vue&type=style&index=0&id=5c1b41bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1b41bc",
  null
  
)

export default component.exports